import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {DataPersonalSellerPf} from '../../models/SellerPf.model';
import {ISellerPayloadData} from '../../interfaces/ISeller';
import {RouteUtils} from "../../../utils/route.utils";
import {BaseService} from "../caronte-base/base.service";
import {SessionStorageEnum} from "../../enums/sessionStorage.enum";
import {SellerPJDataPayload} from "../../models/sellerPj.model";

@Injectable({
  providedIn: 'root',
})
export class FormsService {
  constructor(private baseService: BaseService) {
  }

  getFormsStatusList(): Observable<ISellerPayloadData> {
    return this.baseService.get(RouteUtils.ENTRYPOINTS.GET_SELLERS).pipe(map(data => data.data));
  }

  getNameAndDocument(): { name: string, documentNumber: string } {
    const name = sessionStorage.getItem(SessionStorageEnum.USERNAME)!;
    const userAuth = sessionStorage.getItem(SessionStorageEnum.USER_AUTH)!;
    return {name: name, documentNumber: JSON.parse(userAuth).documentNumber as string};
  }

  postFormSellerPf(data: DataPersonalSellerPf) {
    return this.baseService.put(RouteUtils.ENTRYPOINTS.UPDATE_INDIVIDUAL_SELLER, null, data);
  }

  postFormSellerPj(data: SellerPJDataPayload) {
    return this.baseService.put(RouteUtils.ENTRYPOINTS.UPDATE_CORPORATE_SELLER, null, data);
  }

  patchFinishSellerUpdate() {
    return this.baseService.patch(RouteUtils.ENTRYPOINTS.FINISH_SELLER_UPDATE);
  }
}
